<script>
import api from "@services/api";
import Layout from "@layouts/main";
import UploadFile from "@forms/UploadFile";
import Chamado from "@forms/Chamado";
import ChamadoComentario from "@components/ChamadoComentario";
import ChamadoTimeLine from "@components/ChamadoTimeLine";

export default {
  name: "ChamadoDetalhe",
  page: {
    title: "Chamado Detalhe"
  },
  components: {
    Layout,
    ChamadoTimeLine,
    UploadFile,
    Chamado,
    ChamadoComentario
  },
  data: function() {
    return {
      title: "Chamado Detalhe",
      timelineKey: 0,
      items: [
        {
          text: "Página inicial",
          href: "/"
        },
        {
          text: "Chamado Detalhe",
          active: true
        }
      ],
      item: {
        usuario: { nome: "" },
        projeto: { descricao: "" },
        etapaFluxo: { denominacao: "" },
        chamadoPrioridade: { denominacao: "" }
      },
      chamadoId: null,
      chamadoArquivoList: [],
      chamadoEtapasFluxo: [],
      showFileModal: false,
      showChamadoModal: false,
      files: [],
      chamadoFluxoList: [],
      comentarioObrigatorio: false,
      postFluxo: false,
      etapaFluxoId: undefined,
      showModalComentario: false
    };
  },
  methods: {
    get(id) {
      api.get(`api/Chamado/${id}`).then(response => {
        this.item = response.data["data"];
        this.timelineKey += 1;
      });
    },
    getArquivoList() {
      api
        .get(`api/Chamado/GetListArquivo?chamadoId=${this.chamadoId}`)
        .then(response => {
          this.chamadoArquivoList = response.data["data"];
        });
    },
    showFileUpload() {
      this.showFileModal = true;
    },
    closeFileModal() {
      this.showFileModal = false;
      this.get(this.chamadoId);
      this.getArquivoList();
    },
    editChamado() {
      this.showChamadoModal = true;
    },
    async deleteFile(id) {
      let formData = new FormData();
      formData.append("arquivoId", id);

      var actions = { sim: "Sim", cancel: "Não" };
      var conf = await this.$dialog.confirm({
        text: "Deletar Arquivo?",
        actions: actions,
        position: "middle"
      });

      if (conf == "sim") {
        api.post(`api/chamado/DeleteFile`, formData).then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.get(this.chamadoId);
            this.getArquivoList();
          }
        });
      }
    },
    downloadFile(id) {
      api
        .get(`api/Chamado/DownloadFile`, {
          params: {
            id: id
          }
        })
        .then(response => {
          this.$helper.callDownload(response.data["data"]);
        });
    },
    closeModalChamado() {
      this.$helper.closeModal();
      this.showChamadoModal = false;
      this.get(this.chamadoId);
    },
    back() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Chamado`
        }
      );
    },
    getEtapasFluxo() {
      api.get(`api/Chamado/GetEtapasFluxoChamado`).then(response => {
        this.chamadoFluxoList = response.data["data"];
      });
    },
    listFluxo(id) {
      var perfilNaoCliente = this.user.perfil == "Cliente" ? false : true;
      var PerfilCliente = this.user.perfil == "Cliente" ? true : false;
      return this.chamadoFluxoList
        .filter(
          g =>
            g.etapaIdOrigem == id &&
            (PerfilCliente == g.comandadoCliente ||
              g.comandadoultor == perfilNaoCliente)
        )
        .map(c => ({
          denominacao: c.nomeAcao,
          id: c.id,
          etapaFluxoId: c.etapaIdDestino,
          comentario: c.comentarioObrigatorio
        }));
    },
    changeFluxo(EtapaFluxoId, comentario) {
      if (!comentario) {
        let formData = new FormData();
        formData.append("ChamadoId", this.chamadoId);
        formData.append("EtapaFluxoId", EtapaFluxoId);
        api.post(`api/Chamado/ChangeEtapaFluxo`, formData).then(() => {
          this.get(this.chamadoId);
        });
      } else {
        this.comentarioObrigatorio = comentario;
        this.postFluxo = true;
        this.etapaFluxoId = EtapaFluxoId;
        this.showComentario();
      }
    },
    showComentario() {
      this.$helper.openModal();
      this.showModalComentario = true;
    },
    closeComentario(salvou, comentario, etapaFluxoId, fluxo) {
      if (salvou && fluxo) {
        let formData = new FormData();
        formData.append("ChamadoId", this.chamadoId);
        formData.append("EtapaFluxoId", etapaFluxoId);
        api.post(`api/Chamado/ChangeEtapaFluxo`, formData).then(() => {
          this.get(this.chamadoId);
        });
      } else if (salvou) {
        this.get(this.chamadoId);
      }
      this.showModalComentario = false;
    }
  },
  created() {
    this.chamadoId = parseInt(this.$route.params.id);
    if (this.chamadoId) {
      this.get(this.chamadoId);
    }
    this.getArquivoList();
    this.getEtapasFluxo();
  },
  computed: {
    chamadoArquivoListSubstring: function() {
      return this.chamadoArquivoList.map(c => ({
        denominacao:
          c.denominacao.substring(0, 15) +
          (c.denominacao.length > 15 ? "..." : ""),
        id: c.nomeBlob
      }));
    },
    user() {
      return this.$store.state.auth.user;
    }
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <div class="row">
        <div class="col-12 card">
          <div class="p-2">
            <h4 class="float-right">
              Status: {{ item.etapaFluxo.denominacao }}
            </h4>

            <h4 class="">
              Chamado #{{ item.numero }}

              <span class="badge badge-danger" v-if="item.incidente == true"
                >Incidente</span
              >
            </h4>
            <h4 class="float-right text-muted">
              Prioridade:
              <span :class="`badge ${item.chamadoPrioridade.classeCss}`"
                >{{ item.chamadoPrioridade.denominacao }}
              </span>
              Ordem: {{ item.ordem }}
            </h4>

            <h5 class="font-18 text-muted">
              {{ item.assunto }}
            </h5>
            <hr />
            <div class="media mb-2 mt-1">
              <div class="media-body">
                <span class="float-right">
                  Abertura:
                  {{ item.dataAbertura | formatField("datetime") }}</span
                >
                <h6 class="m-0 font-14">{{ item.usuario.nome }}</h6>
                <h6 class="text-muted">{{ item.projeto.descricao }}</h6>
              </div>
            </div>
            <h6 class="text-muted">Descrição:</h6>
            <p>
              {{ item.descricao }}
            </p>
            <hr />
            <h6>
              <i class="fa fa-paperclip mb-2"></i> Anexos
              <span>({{ chamadoArquivoList.length }})</span>
              <b-button
                variant="light"
                class="btn-sm btn-secondary ml-2"
                v-on:click="showFileUpload()"
                v-if="
                  item.etapaFluxo.denominacao != 'Concluída' &&
                    item.etapaFluxo.denominacao != 'Cancelada'
                "
                ><i class="fe-plus"
              /></b-button>
            </h6>
            <div class="row">
              <div
                class="col-sm-2"
                v-for="aq in chamadoArquivoListSubstring"
                v-bind:key="aq.id"
              >
                <a href="#" @click="downloadFile(aq.id)">{{ aq.denominacao }}</a
                ><i
                  class="fe-trash-2"
                  @click="deleteFile(aq.id)"
                  v-if="
                    item.etapaFluxo.denominacao != 'Concluída' &&
                      item.etapaFluxo.denominacao != 'Cancelada'
                  "
                />
              </div>
            </div>
            <hr />
            <div class="float-right">
              <b-dropdown
                text="Ações"
                variant="light"
                class="mr-2 width-lg"
                v-if="
                  item.etapaFluxo.denominacao != 'Concluída' &&
                    item.etapaFluxo.denominacao != 'Cancelada'
                "
              >
                <b-dropdown-item href="#" @click="showComentario(item.id)"
                  >Comentar</b-dropdown-item
                >
                <b-dropdown-item
                  href="#"
                  @click="changeFluxo(fluxo.etapaFluxoId, fluxo.comentario)"
                  v-for="(fluxo, indexfluxo) in listFluxo(item.etapaFluxoId)"
                  :key="indexfluxo"
                  >{{ fluxo.denominacao }}</b-dropdown-item
                >
              </b-dropdown>
              <b-button variant="light" class="btn" v-on:click="back()"
                >Voltar</b-button
              >
              <b-button
                variant="primary"
                class="btn ml-2"
                v-on:click="editChamado()"
                v-if="
                  item.etapaFluxo.denominacao != 'Concluída' &&
                    item.etapaFluxo.denominacao != 'Cancelada'
                "
                >Editar</b-button
              >
            </div>
          </div>

          <b-modal
            id="fileModal"
            v-model="showFileModal"
            centered
            hide-footer
            title="Upload"
            size="lg"
          >
            <UploadFile
              :showFileModal="showFileModal"
              :executePost="true"
              :origemId="chamadoId"
              :closeModal="closeFileModal"
            />
          </b-modal>

          <ChamadoTimeLine :key="timelineKey" :chamadoId="chamadoId" />

          <b-modal
            id="chamadoModal"
            v-model="showChamadoModal"
            centered
            hide-footer
            title="Chamado"
            size="lg"
          >
            <Chamado
              :chamadoId="chamadoId"
              :editMode="true"
              :closeModalChamado="closeModalChamado"
            />
          </b-modal>

          <b-modal
            id="chamadoComentarioModal"
            v-model="showModalComentario"
            size="lg"
            centered
            hide-footer
            title="Adicionar comentário ao chamado"
            @close="closeComentario(false)"
          >
            <ChamadoComentario
              :chamadoId="chamadoId"
              :closeModalChamado="closeComentario"
              :comentarioObrigatorio="comentarioObrigatorio"
              :changeFluxo="postFluxo"
              :etapaFluxoId="etapaFluxoId"
            />
          </b-modal>
        </div>
      </div>
    </div>
  </Layout>
</template>
